import INBOXTYPE from './inboxType';

const FILTER_TYPE = {
  assignStatus: [
    { value: INBOXTYPE.ALL, text: 'navigation.inbox.all' },
    {
      value: INBOXTYPE.UNASSIGNED,
      text: 'navigation.inbox.unassigned',
    },
    { value: INBOXTYPE.DONE, text: 'navigation.inbox.done' },
    {
      value: INBOXTYPE.ALL_PRIVATE,
      text: 'navigation.inbox.all_private',
    },
    { value: INBOXTYPE.PRIVATE, text: 'navigation.inbox.private' },
    { value: INBOXTYPE.BOT, text: 'navigation.inbox.bot' },
    { value: INBOXTYPE.SPAM, text: 'navigation.inbox.spam' },
    { value: INBOXTYPE.UNFOLLOW, text: 'navigation.inbox.unfollow' },
  ],
  assignPlatform: [
    { value: 'all', text: 'platform.all' },
    { value: 'line', text: 'platform.line' },
    { value: 'facebook', text: 'platform.facebook' },
    { value: 'instagram', text: 'platform.instagram' },
  ],
  assignTimeline: [
    {
      value: 'today',
      text: 'customer-management.all-customers.join-date-filter.today',
    },
    {
      value: 'yesterday',
      text: 'customer-management.all-customers.join-date-filter.yesterday',
    },
    {
      value: 'customTime',
      text: 'customer-management.all-customers.join-date-filter.custom',
    },
  ],
  searchType: [
    {
      value: 'navigation.search.custonmerName',
      placeholder: 'navigation.search.custonmerNamePlaceholder',
    },
    { value: 'navigation.search.message-tab', placeholder: 'chat.inputHint' },
    {
      value: 'chat.search.tag',
      placeholder: 'navigation.search.tagPlaceholder2',
    },
  ],
};

export const ASSIGN_INBOX = FILTER_TYPE.assignStatus
  .filter(
    d =>
      d.value === INBOXTYPE.UNASSIGNED ||
      d.value === INBOXTYPE.DONE ||
      d.value === INBOXTYPE.PRIVATE ||
      d.value === INBOXTYPE.BOT ||
      d.value === INBOXTYPE.SPAM,
  )
  .map(d =>
    d.value === INBOXTYPE.PRIVATE
      ? {
          value: d.value,
          text: FILTER_TYPE.assignStatus.find(
            dd => dd.value === INBOXTYPE.ALL_PRIVATE,
          ).text,
        }
      : d,
  );

export default FILTER_TYPE;
